import axios, { AxiosRequestConfig } from 'axios';
import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';
import { formatTodayGridDate } from './utils';

export const MAXIMUM_ADGROUP_COUNT_UNDER_CAMPAIGN = '10000';

// TODO: Implement fetchAdGroupData function and props
export interface IFetchAdGroupsUrlProps {
  customerId: string;
  accountId: string;
  campaignId: string;
  params?: {
    $top: string;
    $skip: string,
    $count: string;
    $select: string
    $orderby: string;
  };
}

const AdGroupOdataConfig = {
  $expand: 'Campaign($select=BidStrategyName,CampaignCashback,CampaignSettings,CampaignSubType,CampaignType,ExperimentId,Id,Languages,Name),Labels,RSAAdCustomizerAttributes',
  $top: MAXIMUM_ADGROUP_COUNT_UNDER_CAMPAIGN,
  $skip: '0',
  $count: 'true',
  $orderby: 'DeliveryStatus asc',
  $nullifynotapplybidamounts: 'true',
  $select: 'AdGroupType,CommissionRate,CpmBid,CpvBid,DeliveryStatus,DeliveryStatusDetails,DisplayBiddingStrategyType,EndDate,EntityStatus,FinalUrlSuffix,Id,IsBidLandscapeAvailable,Language,Medium,Name,PercentCpcBid,PerformanceMetrics/AbsoluteTopImpressionRate,PerformanceMetrics/ConversionsCredit,PerformanceMetrics/TopImpressionRate,PerformanceMetrics/ViewThroughConversionsCredit,QualityScore/OverallQualityScore,SearchBid,StartDate,TrackingUrlTemplate,UrlCustomParameters',
};

export interface IFetchAdGroupsDataProps extends IFetchAdGroupsUrlProps {
  ccToken: string;
}

export function getFetchAdGroupUrl({
  customerId,
  accountId,
  campaignId,
  params = AdGroupOdataConfig,
}: IFetchAdGroupsUrlProps) {
  const queryString = new URLSearchParams(params);

  return `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts(${accountId})/Campaigns(${campaignId})/AdGroups/Default.GridData?${queryString}`;
}

export function fetchAdGroupsData({
  accountId,
  customerId,
  campaignId,
  ccToken,
}: IFetchAdGroupsDataProps) {
  const url = getFetchAdGroupUrl({ customerId, accountId, campaignId });

  const postDataParams = {
    gridDataParameters: {
      DateRange: {
        StartDate: formatTodayGridDate(),
        EndDate: formatTodayGridDate(),
      },
      CurrentCustomerId: customerId,
    },
  };

  return axios.post(
    url,
    {
      ...postDataParams,
    },
    {
      headers: {
        Authorization: ccToken,
        'content-type': 'application/json',
      },

    } as AxiosRequestConfig,
  );
}
